// DO NEVER IMPORT 3RDPARTY IN COMMONM!
import { toIntNullSafe } from '../util';
import { SEEDDATA_ACCOUNT_ID_ADMIN, SEEDDATA_ACCOUNT_ID_BOB, SEEDDATA_ACCOUNT_ID_MIA, SEEDDATA_AVATAR_URLS_ADMIN, SEEDDATA_AVATAR_URLS_BOB, SEEDDATA_AVATAR_URLS_MIA, SEEDDATA_GROUP_TEAM_A, SEEDDATA_GROUP_TEAM_A_ID, SEEDDATA_GROUP_TEAM_USER_FOO, SEEDDATA_GROUP_TEAM_USER_FOO_ID, SEEDDATA_GROUP_TEAM_X, SEEDDATA_GROUP_TEAM_X_ID, __rest__api__3__myself___TESTID_ADMIN, __rest__api__3__myself___TESTID_BOB, __rest__api__3__myself___TESTID_MIA, } from './internal/static-data';
import { extractMultipleIdsFromUrl } from './mocked-api-helper';
const getNumericUrlParameter = (url, param) => {
    const regex = new RegExp(`${param}=([0-9]+)`);
    const results = url.match(regex);
    return parseInt(results[1], 10);
};
const doReturnErrorWithMessage = (status, message) => ({
    status: status,
    json: () => Promise.resolve({
        errorMessages: [message],
        errors: {},
    }),
});
// With the testId a custom header will be sent to the test backend to return different responses e.g. data for different users
export class CodeclouMockedApi {
    match_from_pathToRegexp;
    testId;
    dbService;
    doThrowErrorInApiUri;
    apiCallUrls = [];
    constructor(match_from_pathToRegexp, testId, dbService, doThrowErrorInApiUri) {
        this.match_from_pathToRegexp = match_from_pathToRegexp;
        this.testId = testId;
        this.dbService = dbService;
        this.doThrowErrorInApiUri = doThrowErrorInApiUri;
    }
    getApiCallUrls() {
        return this.apiCallUrls;
    }
    asApp() {
        return {
            requestJira: async (url, params) => {
                this.apiCallUrls.push(url);
                console.log('called API-URL asApp', url);
                {
                    //
                    // PUT /rest/api/3/field/customfield_10033/context/defaultValue
                    //
                    console.log('URL:URL', url);
                    const matchedUri = url.match('^/rest/api/3/field/.*/context/defaultValue.*');
                    if (matchedUri) {
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/field.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field/:fieldid/context/defaultValue');
                        }
                        // else: do nothing, simple put
                    }
                }
                {
                    //
                    // GET /rest/api/2/group/bulk?${queryParams}
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/2/group/bulk\\?groupId=:groupId&maxResults=:maxResulst&startAt=:startAt', {})(url);
                    if (matchedUri) {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/2/group/bulk.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/2/group/bulk');
                        }
                        const groupId = matchedUri.params['groupId'];
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: GET`, '/rest/api/2/group/bulk?groupId=' + groupId);
                        const availableGroups = [
                            { self: SEEDDATA_GROUP_TEAM_A, name: SEEDDATA_GROUP_TEAM_A, groupId: SEEDDATA_GROUP_TEAM_A_ID },
                            { self: SEEDDATA_GROUP_TEAM_X, name: SEEDDATA_GROUP_TEAM_X, groupId: SEEDDATA_GROUP_TEAM_X_ID },
                            { self: SEEDDATA_GROUP_TEAM_USER_FOO, name: SEEDDATA_GROUP_TEAM_USER_FOO, groupId: SEEDDATA_GROUP_TEAM_USER_FOO_ID },
                        ];
                        const filteredGroups = availableGroups.filter((g) => g.groupId === groupId);
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                values: filteredGroups,
                                total: filteredGroups.length,
                            }),
                        };
                    }
                }
                {
                    //
                    // GET /rest/api/3/user/bulk?${queryParams}
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/user/bulk\\?accountId=:accountId&maxResults=:maxResulst&startAt=:startAt', {})(url);
                    if (matchedUri) {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/user/bulk.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/user/bulk');
                        }
                        const accountId = matchedUri.params['accountId'];
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: GET`, '/rest/api/3/user/bulk?accountId=' + accountId);
                        const availableUsers = [
                            {
                                accountId: SEEDDATA_ACCOUNT_ID_MIA,
                                active: true,
                                timeZone: 'Europe/Berlin',
                                displayName: 'Mia',
                                avatarUrls: SEEDDATA_AVATAR_URLS_MIA,
                            },
                            {
                                accountId: SEEDDATA_ACCOUNT_ID_BOB,
                                active: true,
                                timeZone: 'Europe/Berlin',
                                displayName: 'Bob',
                                avatarUrls: SEEDDATA_AVATAR_URLS_BOB,
                            },
                            {
                                accountId: SEEDDATA_ACCOUNT_ID_ADMIN,
                                active: true,
                                timeZone: 'Europe/Berlin',
                                displayName: 'Bob',
                                avatarUrls: SEEDDATA_AVATAR_URLS_ADMIN,
                            },
                        ];
                        const filteredUsers = availableUsers.filter((u) => u.accountId === accountId);
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                values: filteredUsers,
                                total: filteredUsers.length,
                            }),
                        };
                    }
                }
                //
                // SINGLE OR MULTIPLE CONTEXTS (THREE VARIANTS)
                //
                //  - #1 single: /rest/api/3/field/:fieldid/context\\?maxResults=:maxResults&startAt=:startAt&contextId=:contextId
                //  - #2 multiple as user: /rest/api/3/field/:fieldid/context\\?maxResults=:maxResults&startAt=:startAt&contextId=:contextId&contextId=:contextId&contextId=:contextId&contextId=:contextId&contextId=:contextId
                //  - #3 multiple as admin: /rest/api/3/field/:fieldid/context\\?maxResults=:maxResults&startAt=:startAt
                {
                    const matchedUriSingleOrMultipleContext = this.match_from_pathToRegexp('/rest/api/3/field/:fieldid/context\\?maxResults=:maxResults&startAt=:startAt&contextId=:contextId', {
                        decode: decodeURIComponent,
                    })(url);
                    const matchedUriAllContexts = this.match_from_pathToRegexp('/rest/api/3/field/:fieldid/context\\?maxResults=:maxResults&startAt=:startAt(.*)', { decode: decodeURIComponent })(url);
                    if (matchedUriSingleOrMultipleContext || matchedUriAllContexts) {
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/field.*') && !this.doThrowErrorInApiUri.includes('/defaultValue')) {
                            return doReturnErrorWithMessage(401, 'mocked error /rest/api/3/field/:fieldid/context');
                        }
                        let fieldId = '-1';
                        let contextIds = [];
                        let startAt = 0;
                        let maxResults = 0;
                        if (matchedUriSingleOrMultipleContext) {
                            fieldId = matchedUriSingleOrMultipleContext.params['fieldid'];
                            startAt = toIntNullSafe(matchedUriSingleOrMultipleContext.params['startAt']);
                            maxResults = toIntNullSafe(matchedUriSingleOrMultipleContext.params['maxResults']);
                            const multipleContextIds = extractMultipleIdsFromUrl('contextId', url);
                            contextIds = multipleContextIds.map((i) => toIntNullSafe(i));
                            console.log('ctx ids', contextIds);
                        }
                        else {
                            fieldId = matchedUriAllContexts.params['fieldid'];
                            startAt = toIntNullSafe(matchedUriAllContexts.params['startAt']);
                            maxResults = toIntNullSafe(matchedUriAllContexts.params['maxResults']);
                            contextIds = [];
                        }
                        console.log('MOCK API ROUTE HIT', '/rest/api/3/field/:fieldid/context - fieldid=' + fieldId + ' - contextId=' + contextIds.map((i) => i + "', "));
                        const contexts = await this.dbService.getAllCustomfieldContexts(fieldId);
                        let filteredContexts = contexts.values;
                        if (contextIds.length > 0 && contexts) {
                            filteredContexts = [];
                            for (const contextId of contextIds) {
                                const indexCont = contexts.values.findIndex((x) => `${x.id}` === `${contextId}`);
                                if (indexCont !== -1) {
                                    filteredContexts.push(contexts.values[indexCont]);
                                }
                            }
                        }
                        const isLast = filteredContexts.length <= startAt + maxResults;
                        const sliced = filteredContexts.slice(startAt, startAt + maxResults);
                        contexts.values = sliced;
                        contexts.maxResults = maxResults;
                        contexts.total = filteredContexts.length;
                        contexts.isLast = isLast;
                        return { status: 200, json: () => Promise.resolve(contexts) };
                    }
                }
                {
                    // GET SINGLE CUSTOMFIELD
                    // GET /rest/api/3/field/search\\?id=:id&expand=isLocked
                    // for multiple, see below!
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/search\\?id=:id&expand=isLocked', { decode: decodeURIComponent })(url);
                    if (matchedUri) {
                        if (`${this.doThrowErrorInApiUri}`.startsWith('/rest/api/3/field/search')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field/search');
                        }
                        // console.log('PARAMSSSSS', JSON.stringify(matchedUri.params, null, 2));
                        const fieldId = matchedUri.params['id'];
                        console.log('MOCK API ROUTE HIT', '/rest/api/3/field/search?id=:id - id=' + fieldId);
                        const fields = await this.dbService.getAllCustomfields();
                        const filtered = fields.filter((x) => x.id === fieldId);
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                maxResults: 1,
                                startAt: 0,
                                total: 1,
                                isLast: true,
                                values: filtered,
                            }),
                        };
                    }
                }
                {
                    //
                    // POST /rest/api/3/field/:fid/context/:ctx/option/move
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/:fid/context/:ctx/option/move', {})(url);
                    if (matchedUri && params.method === 'PUT') {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/field')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field/:fid/context/:ctx/option/move');
                        }
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: PUT`, '/rest/api/3/field/:fieldid/context/:contextid/option/move');
                        const fieldId = matchedUri.params['fid'];
                        const contextId = matchedUri.params['ctx'];
                        const bodyParsed = JSON.parse(params.body);
                        await this.dbService.moveCustomfieldContextOption(fieldId, contextId, bodyParsed.customFieldOptionIds[0], bodyParsed.after, bodyParsed.position);
                        return {
                            status: 200,
                            json: () => Promise.resolve({}),
                        };
                    }
                }
                {
                    //
                    // POST /rest/api/3/field/:fid/context/:ctx/option
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/:fid/context/:ctx/option', {})(url);
                    if (matchedUri && params.method === 'POST') {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/field.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field/:fid/context/:ctx/option');
                        }
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: POST`, '/rest/api/3/field/:fieldid/context/:contextid/option');
                        const fieldId = matchedUri.params['fid'];
                        const contextId = matchedUri.params['ctx'];
                        const bodyParsed = JSON.parse(params.body);
                        const optionsPaginated = await this.dbService.createCustomfieldContextOptionsBulk(fieldId, contextId, bodyParsed.options);
                        return {
                            status: 200,
                            json: () => Promise.resolve(optionsPaginated),
                        };
                    }
                }
                {
                    //
                    // PUT /rest/api/3/field/:fid/context/:ctx/option
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/:fid/context/:ctx/option', {})(url);
                    if (matchedUri && params.method === 'PUT') {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/field')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field/:fid/context/:ctx/option');
                        }
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: PUT`, '/rest/api/3/field/:fieldid/context/:contextid/option');
                        const fieldId = matchedUri.params['fid'];
                        const contextId = matchedUri.params['ctx'];
                        const bodyParsed = JSON.parse(params.body);
                        await this.dbService.updateCustomfieldContextOption(fieldId, contextId, bodyParsed.options[0]);
                        return {
                            status: 200,
                            json: () => Promise.resolve(),
                        };
                    }
                }
                {
                    //
                    // DELETE /rest/api/3/field/:fid/context/:ctx/option/:optid
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/:fid/context/:ctx/option/:optid', {})(url);
                    if (matchedUri && params.method === 'DELETE') {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^DELETE-/rest/api/3/field.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error DELETE /rest/api/3/field/:fid/context/:ctx/option/:optid');
                        }
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: DELETE`, '/rest/api/3/field/:fieldid/context/:contextid/option/:optid');
                        const fieldId = matchedUri.params['fid'];
                        const contextId = matchedUri.params['ctx'];
                        const optionId = matchedUri.params['optid'];
                        const res = await this.dbService.deleteCustomfieldContextOption(fieldId, contextId, optionId);
                        return {
                            status: 200,
                            json: () => Promise.resolve(res),
                        };
                    }
                }
                //
                // GET /rest/api/3/field/:fid/context/:ctx/option
                //
                {
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/:fid/context/:ctx/option\\?maxResults=:max&startAt=:start&optionId=:optionId', {})(url);
                    const matchedUriOnlyChildOptions = this.match_from_pathToRegexp('/rest/api/3/field/:fid/context/:ctx/option\\?maxResults=:max&startAt=:start&onlyOptions=true', {})(url);
                    if (matchedUri || matchedUriOnlyChildOptions) {
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/field.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field/:fid/context/:ctx/option');
                        }
                        let optionId = undefined;
                        let fieldId = '0';
                        let contextId = '0';
                        let maxResults = 100;
                        let startAt = 0;
                        if (matchedUriOnlyChildOptions) {
                            optionId = undefined;
                            fieldId = matchedUriOnlyChildOptions.params['fid'];
                            contextId = matchedUriOnlyChildOptions.params['ctx'];
                            maxResults = matchedUriOnlyChildOptions.params['max'];
                            startAt = matchedUriOnlyChildOptions.params['start'];
                        }
                        else {
                            optionId = matchedUri.params['optionId'];
                            fieldId = matchedUri.params['fid'];
                            contextId = matchedUri.params['ctx'];
                            maxResults = matchedUri.params['max'];
                            startAt = matchedUri.params['start'];
                        }
                        console.log(`MOCK API ROUTE HIT - METHOD: GET`, '/rest/api/3/field/:fieldid/context/:contextid/option - fieldid=' + fieldId + ' contextid=' + contextId + ' maxResults=' + maxResults + ' startAt=' + startAt + ' optionId=' + optionId);
                        const optionsPaginated = await this.dbService.getAllCustomfieldContextOptions(fieldId, contextId, startAt, maxResults, optionId);
                        // console.log('OPTS PAGIN', JSON.stringify(optionsPaginated, null, 2));
                        return {
                            status: 200,
                            json: () => Promise.resolve(optionsPaginated),
                        };
                    }
                }
                //
                // AS-USER:
                //   GET rest/api/3/field/search?id=customfield_10033&id=customfield_10044&startAt=0&maxResults=10000&expand=isLocked&type=custom&orderBy=name
                // AS-ADMIN:
                //   GET rest/api/3/field/search?startAt=0&maxResults=10000&expand=isLocked&type=custom&orderBy=name
                //
                // MUST BE LAST!!!!!!!!!!!!!!!
                //
                if (`${url}`.startsWith('/rest/api/3/field/search')) {
                    if (`${this.doThrowErrorInApiUri}`.startsWith('/rest/api/3/field')) {
                        return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/field');
                    }
                    if (`${url}`.startsWith('/rest/api/3/field/search?id=')) {
                        // USER
                        console.log('MOCK API ROUTE HIT ', url);
                        const newUrl = url.replace('/rest/api/3/field/search?id=', '');
                        const startAt = getNumericUrlParameter(url, 'startAt');
                        const maxResults = getNumericUrlParameter(url, 'maxResults');
                        const newUrl2 = newUrl.replace(`&startAt=${startAt}&maxResults=${maxResults}&expand=isLocked&type=custom&orderBy=name`, '');
                        const urlFieldIds = newUrl2.split('&');
                        const idsFiltered = urlFieldIds.map((id) => id.replace('id=', ''));
                        const fields = await this.dbService.getAllCustomfields();
                        const filtered = fields.filter((x) => idsFiltered.includes(x.id));
                        // console.log('fieldIds: ', JSON.stringify(idsFiltered, null, 2))
                        console.log('startAt', startAt);
                        console.log('maxResults', maxResults);
                        const isLast = filtered.length <= startAt + maxResults;
                        const pagedResult = filtered.slice(startAt, startAt + maxResults);
                        // console.log('pagedResult', pagedResult);
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                maxResults: maxResults,
                                startAt: startAt,
                                total: pagedResult.length,
                                isLast: isLast,
                                values: pagedResult,
                            }),
                        };
                    }
                    else {
                        // ADMIN
                        let startAt = 0;
                        let maxResults = 0;
                        let query = null;
                        if (url.includes('query=')) {
                            const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/search\\?startAt=:startAt&maxResults=:maxResults&expand=isLocked&query=:query&type=custom&orderBy=name', {})(url);
                            startAt = toIntNullSafe(matchedUri.params['startAt']);
                            maxResults = toIntNullSafe(matchedUri.params['maxResults']);
                            query = matchedUri.params['query'];
                        }
                        else {
                            const matchedUri = this.match_from_pathToRegexp('/rest/api/3/field/search\\?startAt=:startAt&maxResults=:maxResults&expand=isLocked&type=custom&orderBy=name', {})(url);
                            startAt = toIntNullSafe(matchedUri.params['startAt']);
                            maxResults = toIntNullSafe(matchedUri.params['maxResults']);
                        }
                        console.log(`MOCK API: ${query ? 'with filter' : 'without filter'} /rest/api/3/field/search?startAt=${startAt}&maxResults=${maxResults}&expand=isLocked&query=${query}&type=custom&orderBy=name`);
                        let fields = await this.dbService.getAllCustomfields();
                        if (query) {
                            fields = fields.filter((x) => x.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
                        }
                        const isLast = fields.length <= startAt + maxResults;
                        const sliced = fields.slice(startAt, startAt + maxResults);
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                maxResults: maxResults,
                                startAt: startAt,
                                total: fields.length,
                                isLast: isLast,
                                values: sliced,
                            }),
                        };
                    }
                }
                return { status: 200, json: () => Promise.resolve({ message: 'empty' }) };
            },
        };
    }
    asUser() {
        return {
            requestJira: async (url, params) => {
                this.apiCallUrls.push(url);
                console.log('called API-URL asUser', url);
                {
                    //
                    // GET /rest/api/3/user/picker?${queryParams}
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/user/picker\\?query=:query&showAvatar=true', {})(url);
                    if (matchedUri) {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/user/picker.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/user/picker');
                        }
                        const query = matchedUri.params['query'];
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: GET`, `/rest/api/3/user/picker?query=${query}&showAvatar=true`);
                        const availableUsers = [
                            {
                                accountId: SEEDDATA_ACCOUNT_ID_MIA,
                                accountType: 'atlassian',
                                name: 'Mia',
                                key: 'mia',
                                html: 'true',
                                displayName: 'Mia',
                                avatarUrl: SEEDDATA_AVATAR_URLS_MIA['16x16'],
                            },
                            {
                                accountId: SEEDDATA_ACCOUNT_ID_BOB,
                                accountType: 'atlassian',
                                name: 'Bob',
                                key: 'bob',
                                html: 'true',
                                displayName: 'Bob',
                                avatarUrl: SEEDDATA_AVATAR_URLS_BOB['16x16'],
                            },
                            {
                                accountId: SEEDDATA_ACCOUNT_ID_ADMIN,
                                accountType: 'atlassian',
                                name: 'Admin',
                                key: 'admin',
                                html: 'true',
                                displayName: 'Admin',
                                avatarUrl: SEEDDATA_AVATAR_URLS_ADMIN['16x16'],
                            },
                        ];
                        const filteredUsers = availableUsers.filter((u) => u.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                users: filteredUsers,
                                total: filteredUsers.length,
                            }),
                        };
                    }
                }
                {
                    //
                    // GET /rest/api/3/groups/picker?${queryParams}
                    //
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/groups/picker\\?query=:query&showAvatar=true', {})(url);
                    if (matchedUri) {
                        // ON ERROR
                        if (`${this.doThrowErrorInApiUri}`.match('^/rest/api/3/groups/picker.*')) {
                            return doReturnErrorWithMessage(400, 'mocked error /rest/api/3/groups/picker');
                        }
                        const query = matchedUri.params['query'];
                        // ON SUCCESS
                        console.log(`MOCK API ROUTE HIT - METHOD: GET`, `/rest/api/3/groups/picker?query=${query}`);
                        const availableGroups = [
                            { name: SEEDDATA_GROUP_TEAM_A, groupId: SEEDDATA_GROUP_TEAM_A_ID },
                            { name: SEEDDATA_GROUP_TEAM_X, groupId: SEEDDATA_GROUP_TEAM_X_ID },
                            { name: SEEDDATA_GROUP_TEAM_USER_FOO, groupId: SEEDDATA_GROUP_TEAM_USER_FOO_ID },
                        ];
                        const filteredGroups = availableGroups.filter((g) => g.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                groups: filteredGroups,
                                total: filteredGroups.length,
                            }),
                        };
                    }
                }
                if (`${url}`.startsWith('/rest/api/3/myself')) {
                    console.log('MOCK API ROUTE HIT', '/rest/api/3/myself');
                    if (`${this.doThrowErrorInApiUri}`.startsWith('/rest/api/3/myself')) {
                        return doReturnErrorWithMessage(401, 'mocked error /rest/api/3/myself');
                    }
                    if (this.testId === 'TESTID_MIA') {
                        return { status: 200, json: () => Promise.resolve(__rest__api__3__myself___TESTID_MIA) };
                    }
                    if (this.testId === 'TESTID_BOB') {
                        return { status: 200, json: () => Promise.resolve(__rest__api__3__myself___TESTID_BOB) };
                    }
                    if (this.testId === 'TESTID_ADMIN') {
                        return { status: 200, json: () => Promise.resolve(__rest__api__3__myself___TESTID_ADMIN) };
                    }
                }
                {
                    const matchedUri = this.match_from_pathToRegexp('/rest/api/3/mypermissions\\?permissions=ADMINISTER', {})(url);
                    // /rest/api/3/mypermissions?permissions=ADMINISTER
                    if (matchedUri) {
                        if (`${this.doThrowErrorInApiUri}`.startsWith('/rest/api/3/mypermissions')) {
                            return doReturnErrorWithMessage(401, 'mocked error /rest/api/3/mypermissions');
                        }
                        console.log('MOCK API ROUTE HIT', '/rest/api/3/mypermissions');
                        let isAdmin = false;
                        if (this.testId === 'TESTID_MIA') {
                            isAdmin = false;
                        }
                        if (this.testId === 'TESTID_BOB') {
                            isAdmin = false;
                        }
                        if (this.testId === 'TESTID_ADMIN') {
                            isAdmin = true;
                        }
                        return {
                            status: 200,
                            json: () => Promise.resolve({
                                permissions: {
                                    ADMINISTER: {
                                        id: '0',
                                        key: 'ADMINISTER',
                                        name: 'Administer Jira',
                                        type: 'GLOBAL',
                                        description: 'foo',
                                        havePermission: isAdmin,
                                    },
                                },
                            }),
                        };
                    }
                }
                return { status: 200, json: () => Promise.resolve('foo') };
            },
        };
    }
}
// used in frontend-dev mock and common tests!
export const mockedResolver = {
    define: (f) => { },
};
// used in frontend-dev mock and common tests!
// Identity "tagged template luterals" tags
export const mockedRoute = (template, ...args) => {
    let str = '';
    for (let i = 0; i < args.length; i++) {
        str += template[i] + String(args[i]);
    }
    return str + template[template.length - 1];
};
